import { render, staticRenderFns } from "./PracticeResourceAdd.vue?vue&type=template&id=c2f30568&scoped=true&"
import script from "./PracticeResourceAdd.vue?vue&type=script&lang=js&"
export * from "./PracticeResourceAdd.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f30568",
  null
  
)

export default component.exports